import { UserDTO } from '@inversor-hub/types';

// TODO: move this permission gate to feature flags.
export const ALLOWED_CO_INVESTMENT_CREATOR_ID = '99d77d84-8421-4eb8-a3b5-4813c9545469';

export const canCreateCoInvestment = (user?: Pick<UserDTO, 'id' | 'role'>): boolean => {
  return user?.role === 'psi' && user.id === ALLOWED_CO_INVESTMENT_CREATOR_ID;
};
